export default "__VITE_ASSET__BIL6Dn34__"